module.exports = __webpack_public_path__ + "static/media/dashboard.inactive.240f3713.svg";